/*
 * @Author: fanglijuan
 * @Date:   2018-1-5
 * 报纸管理通用导航切换模块
 */
"use strict";
angular.module("newspaperNavModule", [])
    .directive("newspaperNav", ["$state", '$q', "$timeout", "$location", "modalDialog", "trsHttpService", "getNewsNameService", "productMangageMentNewspaperService",
        function($state, $q, $timeout, $location, modalDialog, trsHttpService, getNewsNameService, productMangageMentNewspaperService) {
            return {
                restrict: "E",
                replace: false,
                templateUrl: "./manageConfig/productManageMent/newspaper/directive/nav/paperNav_tpl.html",
                scope: {
                    /*item: "@",*/
                    /*callback: "&",*/
                },
                link: function(scope, $element, $attrs) {
                    initStatus();
                    initData();
                    /**
                     * [initStatus description]初始化状态
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        scope.status = {
                            isTab: $location.path().split("/")[4],
                            item: '',
                            rights: {},
                            SITEID: $location.search().paper
                        };
                        getNewsNameService.getNewsName(scope.status.SITEID).then(function(data) {
                            scope.status.item = data;
                        });
                    }
                    /**
                     * [initData description]初始化数据
                     * @return {[type]} [description]
                     */
                    function initData() {
                        getSiteRights().then(function() {
                            redirection();
                        });
                    }
                    /**
                     * [redirection description] 根据权限重定向
                     * @return {[type]} [description]
                     */
                    function redirection() {
                        $timeout(function() {
                            var curUrlName = $state.current.name.replace(/manageconfig.productmanage.newspaper./g, "");
                            var $lis = $element.find("li");
                            var flag = true;
                            $element.find("li").each(function() {
                                var $a = $(this).find("a");
                                var urlName = $a.attr("sref");
                                if (urlName.indexOf(curUrlName) >= 0) {
                                    flag = false;
                                }
                            });
                            if (flag) {
                                $element.find("li a")[0].click();
                            }
                        });
                    }
                    /**
                     * [getSiteRights description]获取每个站点的操作权限
                     * @return {[type]}        [description]
                     */
                    function getSiteRights() {
                        var deffer = $q.defer();
                        productMangageMentNewspaperService.getRight(scope.status.SITEID, "", "papersetpaper").then(function(data) {
                            scope.status.rights = data;
                            deffer.resolve();
                        });
                        return deffer.promise;
                    }
                    /**
                     * [goto description]点击路由跳转
                     * @param  {[type]} router [description]
                     * @param  {[type]} SITEID [description]
                     * @return {[type]}        [description]
                     */
                    scope.goto = function(router, SITEID) {
                        doJump(router, SITEID);
                    };
                    /**
                     * [doJump description]执行路由跳转
                     * @param  {[type]} router [description]
                     * @param  {[type]} SITEID [description]
                     * @return {[type]}        [description]
                     */
                    function doJump(router, SITEID) {
                        var url = "manageconfig.productmanage.newspaper." + router;
                        $state.go(url, {
                            "paper": SITEID
                        });
                    }
                    //点击采编版面,判断该报纸下是否存在叠次
                    scope.goEditLayout = function(SITEID) {
                        var params = {
                            "serviceid": "mlf_paperset",
                            "methodname": "queryDieCis",
                            "PaperId": SITEID
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            if (data.length < 1) {
                                modalDialog.alertType("请先在该报纸下启用或添加叠次", "", "warning", false);
                            } else {
                                doJump("editlayout", scope.status.SITEID);
                            }
                        });
                    };
                    //点击照排版面,判断该报纸下是否存在叠次
                    scope.goZPLayout = function(item) {
                        if (item.ISZHAOPAI == 0) return;
                        var params = {
                            "serviceid": "mlf_paperset",
                            "methodname": "queryDieCis",
                            "PaperId": item.SITEID
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            if (data.length < 1) {
                                modalDialog.alertType("请先在该报纸下启用或添加叠次", "", "warning", false);
                            } else {
                                doJump("typesettingpage", item.SITEID);
                            }
                        });
                    };
                }
            };
        }
    ]);